import React, { FC } from 'react'
import { ASSETS } from '../../../../constants/assets'
import formatInlineCode from '../../../../utils/shortTextFormatting'
import Button from '../../button'
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'
import { SubscribeAd, SubscribeBanner } from '../style'

type Props = {
  i: number
  generateBlogFR: any
  subscribe: any
  blogPost: any
  isMainBlog: boolean
}

export const LastPage: FC<Props> = ({ i, generateBlogFR, subscribe, blogPost, isMainBlog }) => {
  const subscribeBanner = isMainBlog && (
    <SubscribeBanner key={`SubscribeBanner-${i}`}>
      <div className="SubscribeBanner__Inner">
        <Typography className="SubscribeBanner-Header" type="header5">
          {subscribe?.bannerHeadline || ''}
        </Typography>

        <Button
          icon={true}
          text="Subscribe"
          type="secondary"
          size="small"
          theme="dark"
          className="SubscribeModal__Trigger"
        />
      </div>
    </SubscribeBanner>
  )

  const subscribeAd = isMainBlog && (
    <SubscribeAd key={`SubscribeAd-${i}`}>
      <div className="SubscribeAd__Inner">
        <div className="SubscribeAd__Img-Container">
          <WrapperImage
            className="SubscribeAd__Img"
            src={ASSETS.MAIL_ICON}
            alt="Mail Icon"
            width={64}
            height={64}
            threshold={650}
          />
        </div>

        <Typography className="SubscribeAd-Header" type="header5">
          {subscribe?.teaserHeadline || ''}
        </Typography>

        <Typography className="SubscribeAd-Body font__inter" type="bodyXS">
          {formatInlineCode(subscribe?.teaserBody || '')}
        </Typography>

        <Button
          icon={true}
          text="Subscribe"
          type="primary"
          size="small"
          theme="dark"
          className="SubscribeModal__Trigger"
        />
      </div>
    </SubscribeAd>
  )

  return (
    <>
      {blogPost}
      {subscribe ? subscribeBanner : null}
      {subscribe ? subscribeAd : null}
      {generateBlogFR()}
    </>
  )
}
